import { useEffect, useState } from "react";

import { APICallStatus } from "src/contentful";
export type UserLocale = "US" | "JP";
export const DEFAULT_COUNTRY_CODE: UserLocale = "US";
export const LOCALE_CACHE_KEY = "bxp.currentLocale";
export const COUNTRY_CODE_TO_CURRENCY: Record<UserLocale, string> = {
    US: "USD",
    JP: "JPY"
};

export async function fetchUserLocale(baseUrl: string): Promise<UserLocale> {
    let localeFromStorage;
    if (typeof window !== "undefined") {
        localeFromStorage = sessionStorage.getItem(
            LOCALE_CACHE_KEY
        ) as UserLocale;
    }

    if (localeFromStorage) {
        return Promise.resolve(localeFromStorage);
    }
    return await fetch(`${baseUrl}/location`)
        .then((response) => response.json())
        .then(
            (json) =>
                (json.countryIsoCode as UserLocale) || DEFAULT_COUNTRY_CODE
        )
        .catch(() => DEFAULT_COUNTRY_CODE);
}

export function useGeoLocation(baseUrl: string) {
    const [status, setStatus] = useState<APICallStatus>("idle");
    const [countryCode, setCountryCode] = useState<UserLocale>();
    useEffect(() => {
        const fetchData = async () => {
            setStatus("fetching");
            const locale = await fetchUserLocale(baseUrl);
            setStatus("complete");
            setCountryCode(locale);
        };
        fetchData();
    }, []);
    return { status, countryCode };
}
